export default {
  email: 'E-mail',
  login: 'Login',
  senha: 'Senha',
  acessar: 'ACESSAR',
  faca_login: 'Faça o seu login',
};
